import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormattedMessage, injectIntl } from "react-intl";
import { ProgressBar } from "react-bootstrap";
import { resendOtpCode, verifyOtpCode } from "../_redux/authCrud";
import * as auth from "../_redux/authRedux";

const initialValues = {
  otpCode: ""
};

function OtpVerification(props) {
  const { intl } = props;
  const { authData } = props;
  const [sending, setSending] = useState(false);
  const [remaining, setRemaining] = useState(30);
  const variant = remaining / 30 >= 0 && remaining / 30 < 0.125 ? "danger" :
                  remaining / 30 >= 0.125 && remaining / 30 < 0.5 ? "warning" :
                  remaining / 30 >= 0.5 ? "info" : "";

  const OtpVerificationSchema = Yup.object().shape({
    username: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    //validationSchema: OtpVerificationSchema,
    onSubmit: (values, { setValues, setStatus, setSubmitting }) => {
      const loginData = {
        domain: authData.domain,
        authId: authData.authId,
        otpCode: values.otpCode,
        token: props.token
      };
      setTimeout(() => {        
        verifyOtpCode(loginData)
        .then(({ data: {
           isSuccess,
           type,
           message,
           authToken,
           currentUser
          }}) => {
          if (type === "error") type = "danger";   
          setValues(type);
          setStatus(message);
          if (isSuccess) props.login(currentUser, authToken);
        })
        .catch(() => {
          setValues("danger");
          setStatus(
            "İşlem Sırasında Bir Hata Oluştu. Lütfen Sistem Yöneticiniz İle İrtibata Geçiniz!"
              // intl.formatMessage({
              //   id: "AUTH.VALIDATION.INVALID_LOGIN",
              // })
          );
        })
        .finally(() => {
          setSubmitting(false);
        });
      }, 1000);
    },
  });

  const resendCode = () => {
    setSending(true);
    resendOtpCode(authData)
    .then(({ data: {
       isSuccess,
       message
      }}) => {
      if (isSuccess) {
        setRemaining(30);
        formik.setStatus("");

      } else {
        formik.setValues("danger");
        formik.setStatus(message);
      }
    })
    .catch(() => {
      formik.setValues("danger");
      formik.setStatus(
        "İşlem Sırasında Bir Hata Oluştu. Lütfen Sistem Yöneticiniz İle İrtibata Geçiniz!"
              // intl.formatMessage({
              //   id: "AUTH.VALIDATION.INVALID_LOGIN",
              // })
      );
    })
    .finally(() => {
        setSending(false);
    })
  };
  
  useEffect(() => {
    let timer;

    if (!formik.isSubmitting) {
      timer = setInterval(() => {
        setRemaining(prev => prev === 0 ? 0 : prev - 1);
      }, 1000);
    }    
    return () => clearInterval(timer);
  }, [formik.isSubmitting]);

 return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">
          {authData.schoolName}
        </h3>
      </div>

      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
      >
        {formik.status ? (
          <div className={`mb-10 alert alert-custom alert-light-${formik.values} alert-dismissible`}>
            <div className="alert-text font-weight-bold">
              {formik.status}
            </div>
          </div>
        ) : remaining > 0 ? (
          <div className="mb-10 alert alert-custom alert-light-info alert-dismissible">
            <div className="alert-text">
              Lütfen sistemde kayıtlı xxxxxx{props.phoneFourChar} numaralı telefonunuza gönderilen <strong>doğrulama kodunu</strong> giriniz.
              <br />
              Kodun geçerlilik süresi <strong>2 dk</strong> dır.
            </div>
          </div>
        ) : (
          <div className="mb-10 alert alert-custom alert-light-warning alert-dismissible">
            <div className="alert-text font-weight-bold">
              Gönderilen kodun geçerlilik süresi dolmuştur. Giriş yapmak için tekrar kod gönderiniz.
            </div>
          </div>
        )}

        <div className="form-group d-flex flex-wrap flex-center">
          <span>Kalan süre: <strong>{remaining}</strong> sn</span>
        </div>

        <div className="form-group">
          <ProgressBar striped variant={variant} now={remaining / 30 * 100} />
        </div>
        
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="Doğrulama Kodu"
            type="number"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "otpCode"
            )}`}
            name="otpCode"
            disabled={remaining <= 0}
            {...formik.getFieldProps("otpCode")}
          />
          {formik.touched.otpCode && formik.errors.otpCode ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.otpCode}</div>
            </div> 
          ) : null}
        </div>

        <div className="form-group d-flex flex-wrap flex-center">
          {
            remaining > 0 &&
              <button
              id="kt_login_otp_submit"
              type="submit"
              className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
              disabled={formik.isSubmitting}
            >
              {!formik.isSubmitting && <span>Giriş Yap</span>}
              {
                formik.isSubmitting && 
                <>
                  <span>Giriş Yapılıyor</span>
                  <span className="ml-3 spinner spinner-white"></span>
                </>
              }
            </button>
          }          
          {
            remaining <= 0 &&
            <button
              type="button"
              id="kt_login_otp_resend"
              className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
              onClick={resendCode}
              disabled={sending}
            >
              {!sending && <span>Tekrar Kod Gönder</span>}
              {
                sending && 
                <>
                  <span>Tekrar Kod Gönderiliyor</span>
                  <span className="ml-3 spinner spinner-white"></span>
                </>
              }
            </button>
          }
        </div>
      </form>
    </div>
  );
}

export default injectIntl(connect(
  ({ auth }) => ({ userId: auth.userId, phoneFourChar: auth.phoneFourChar, token: auth.token }),
  auth.actions
)(OtpVerification));